import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Redirect, withRouter } from 'react-router';

import { bookingShape } from 'constants/propTypes';
import { withBooking } from 'components/queries/GetBookingQuery';
import { getBookingItemRefsFromParams } from 'utils/exchange';
import { getBookingJourneysURL } from 'utils/urls';

import ExchangeDetails from './ExchangeDetails';

const Exchange = ({
  booking,
  location: { search, state },
  match: {
    params: { reference }
  },
  ...props
}) => {
  const bookingItemRefs = getBookingItemRefsFromParams(search);
  const membershipNumber = new URLSearchParams(search).get('membershipNumber');

  /*
    using useState here because we need to save the overrideReason on first render
    When the user changes the data on the exchange results page the date is changed in url
    and state is cleared
  */
  const [overrideReason] = useState(state ? state.overrideReason : null);

  if (booking.isMigratedMulti) {
    // Only the cancellation of the entire booking is possible for migrated multi-inventory bookings
    const journeysPath = getBookingJourneysURL(reference);

    return <Redirect to={journeysPath} />;
  }

  return (
    <ExchangeDetails
      booking={booking}
      reference={reference}
      bookingItemRefs={bookingItemRefs}
      overrideReason={overrideReason}
      membershipNumber={membershipNumber}
      {...props}
    />
  );
};

Exchange.propTypes = {
  booking: bookingShape.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    state: PropTypes.object
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      reference: PropTypes.string.isRequired
    })
  })
};

const options = {
  centerLoader: true
};
export default withBooking(withRouter(Exchange), undefined, options);
